import * as React from 'react';
import styled from 'styled-components';

const Container = styled.div`
	 {
		display: flex;
		flex-wrap: nowrap;
		flex: 100%;
		align-items: center;
		@media (max-width: 795px) {
			flex-wrap: wrap;
			line-height: 15px;
		}
	}
`;
Container.displayName = 'Container';

const LogoContainer = styled.div`
	 {
		overflow: hidden;
		padding-right: 30px;
		white-space: nowrap;
	}
`;
LogoContainer.displayName = 'LogoContainer';

const Logo = styled.img`
	 {
		width: 30px;
		height: 30px;
	}
`;
Logo.displayName = 'Logo';

const DisplayText = styled.div.attrs<IDisplayTextWithDetailsProps, any>({ className: (props: IDisplayTextWithDetailsProps) => props })`
	 {
		flex: 60%;
		overflow: hidden;
		padding-right: 5px;
		text-overflow: ellipsis;
		white-space: nowrap;
		display: flex;
		align-items: center;

		${(props) =>
			props.logo !== undefined
				? `&::before {
				content: '';
				background-image: url(${props.logo});
				background-repeat: no-repeat;
				background-position: 0px 0px;
				background-size: 30px 30px;
				width: 30px;			
				height: 30px;
				margin-right: 20px;
			}`
				: ''}
	}
`;
DisplayText.displayName = 'DisplayText';

const Details = styled.div.attrs<IDisplayTextWithDetailsProps, any>({ className: (props: IDisplayTextWithDetailsProps) => props })`
	 {
		${(props) => (props.logo !== undefined ? 'flex: 30%;' : 'flex: 40%;')}
		font-size: 10px;
		font-style: italic;
		margin-left: 10px;
		text-align: right;
		@media (max-width: 795px) {
			text-align: left;
			margin-left: 0;
		}
		.tws-tooltip {
			text-align: left;
		}
	}
`;
Details.displayName = 'Details';

interface IDisplayTextWithDetailsProps {
	displayText: string;
	details?: any;
	logo?: string;
}

export class DisplayTextWithDetails extends React.Component<IDisplayTextWithDetailsProps> {
	public render() {
		return (
			<Container>
				<DisplayText {...this.props} title={this.props.displayText}>
					{this.props.displayText}
				</DisplayText>
				{this.props.details && <Details {...this.props}>{this.props.details}</Details>}
			</Container>
		);
	}
}
